<div class="row">
    <div class="col-xl-4">
        <div class="card card-box mb-5">
            <div class="card-header bg-secondary">
                <div class="card-header--title">
                    <h5 class="mb-0 py-2 font-weight-bold">
                        Latest actions
                    </h5>
                </div>
                <div class="card-header--actions">
                    <div class="btn-group btn-group-sm" dropdown>
                        <button class="btn btn-sm dropdown-toggle no-caret btn-primary" dropdownToggle
                                type="button">
                            Export
                            <fa-icon [icon]="['fas', 'chevron-down']" class="opacity-8 font-size-xs ml-1"></fa-icon>
                        </button>
                        <div *dropdownMenu class="dropdown-menu dropdown-menu-xl dropdown-menu-right">
                            <ul class="nav nav-neutral-dark nav-pills flex-column px-3">
                                <li class="nav-item nav-item--header px-0">
                                    <span class="text-capitalize text-black font-size-md font-weight-bold">Export menu</span>
                                </li>
                                <li class="dropdown-divider"></li>
                                <li class="nav-item">
                                    <a [routerLink]="" class="nav-link">
                                        <span>View all reports</span>
                                    </a>
                                </li>
                                <li class="nav-item">
                                    <a [routerLink]="" class="nav-link active">
                                        <span>View active items</span>
                                        <div class="ml-auto badge badge-success">23</div>
                                    </a>
                                </li>
                                <li class="nav-item pt-4 nav-item--header">
                                    <span class="text-black font-weight-bold">Options</span>
                                </li>

                                <li class="nav-item">
                                    <a [routerLink]="" class="nav-link">
                                        <div class="nav-link-icon">
                                            <fa-icon [icon]="['fas', 'download']"></fa-icon>
                                        </div>
                                        <span>Download</span>
                                    </a>
                                </li>
                                <li class="nav-item">
                                    <a [routerLink]="" class="nav-link">
                                        <div class="nav-link-icon">
                                            <fa-icon [icon]="['far', 'file-excel']"></fa-icon>
                                        </div>
                                        <span>Export to CSV</span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card-body p-0">
                <div class="list-group mb-2 list-group-flush">
                    <div class="list-group-item py-3 border-0">
                        <div class="align-box-row w-100">
                            <div class="mr-3">
                                <div class="bg-neutral-dark text-primary text-center font-size-xl d-60 rounded-sm">
                                    <fa-icon [icon]="['far', 'bell']"></fa-icon>
                                </div>
                            </div>
                            <div>
                                <div class="font-weight-bold d-block opacity-8">Customers</div>
                                <div class="text-dark opacity-5">
                                    A wonderful serenity has taken possession of my entire soul.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="divider"></div>
                    <div class="list-group-item py-3 border-0">
                        <div class="align-box-row w-100">
                            <div class="mr-3">
                                <div class="bg-neutral-dark text-primary text-center font-size-xl d-60 rounded-sm">
                                    <fa-icon [icon]="['far', 'object-group']"></fa-icon>
                                </div>
                            </div>
                            <div>
                                <div class="font-weight-bold d-block opacity-8">New articles</div>
                                <div class="text-dark opacity-5">
                                    I am alone, and feel the charm of existence in this spot.
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="divider"></div>
                    <div class="list-group-item py-3 border-0">
                        <div class="align-box-row w-100">
                            <div class="mr-3">
                                <div class="bg-neutral-dark text-primary text-center font-size-xl d-60 rounded-sm">
                                    <fa-icon [icon]="['far', 'chart-bar']"></fa-icon>
                                </div>
                            </div>
                            <div>
                                <div class="font-weight-bold d-block opacity-8">Blog posts</div>
                                <div class="text-dark opacity-5">
                                    When, while the lovely valley teems with vapour around me.
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-xl-4">
        <div class="card card-box mb-5">
            <div class="card-header bg-secondary">
                <div class="card-header--title">
                    <h5 class="mb-0 py-2 font-weight-bold">
                        Pricing Plans
                    </h5>
                </div>
                <div class="card-header--actions">
                    <button class="btn btn-sm btn-success py-1 px-3 text-uppercase" type="button">
                        <small>Add new</small>
                    </button>
                </div>
            </div>
            <div class="card-body p-0">
                <div class="list-group my-3 list-group-flush">
                    <div class="list-group-item list-group-item-action hover-show-hide-container d-flex justify-content-between align-items-center py-3 border-0">
                        <div class="badge badge-success badge-circle mt-2 mr-2 align-self-start">Basic</div>
                        <div class="font-weight-bold flex-grow-1">
                            <div class="text-second font-size-lg">
                                Basic
                            </div>
                            <span class="opacity-8">
                                <fa-icon [icon]="['far', 'user']" class="mr-1"></fa-icon>
                                <b>3847</b>
                                subscribers
                            </span>
                        </div>
                        <div class="text-right hover-hide-wrapper">
                            <div class="font-weight-bold text-second">$176.00</div>
                            <span class="opacity-7">per month</span>
                        </div>
                        <div class="text-right hover-show-wrapper">
                            <button class="btn bg-white text-first d-40 rounded-circle p-0 ml-1"
                                    containerClass="tooltip-first"
                                   tooltip="View details" type="button">
                                <fa-icon [icon]="['far', 'user']" class="font-size-md mx-auto"></fa-icon>
                            </button>
                            <button class="btn bg-white text-danger d-40 rounded-circle p-0 ml-1"
                                    containerClass="tooltip-danger"
                                   tooltip="Remove" type="button">
                                <fa-icon [icon]="['fas', 'times']" class="font-size-md mx-auto"></fa-icon>
                            </button>
                        </div>
                    </div>
                    <div class="list-group-item list-group-item-action hover-show-hide-container d-flex justify-content-between align-items-center py-3 border-0">
                        <div class="badge badge-danger badge-circle mt-2 mr-2 align-self-start">Basic</div>
                        <div class="font-weight-bold flex-grow-1">
                            <div class="text-second font-size-lg">
                                Premium
                            </div>
                            <span class="opacity-8">
                                <fa-icon [icon]="['far', 'user']" class="mr-1"></fa-icon>
                                <b>346</b>
                                subscribers
                            </span>
                        </div>
                        <div class="text-right hover-hide-wrapper">
                            <div class="font-weight-bold text-second">$567.00</div>
                            <span class="opacity-7">per month</span>
                        </div>
                        <div class="text-right hover-show-wrapper">
                            <button class="btn bg-white text-first d-40 rounded-circle p-0 ml-1"
                                    containerClass="tooltip-first"
                                   tooltip="View details" type="button">
                                <fa-icon [icon]="['far', 'user']" class="font-size-md mx-auto"></fa-icon>
                            </button>
                            <button class="btn bg-white text-danger d-40 rounded-circle p-0 ml-1"
                                    containerClass="tooltip-danger"
                                   tooltip="Remove" type="button">
                                <fa-icon [icon]="['fas', 'times']" class="font-size-md mx-auto"></fa-icon>
                            </button>
                        </div>
                    </div>
                    <div class="list-group-item list-group-item-action hover-show-hide-container d-flex justify-content-between align-items-center py-3 border-0">
                        <div class="badge badge-first badge-circle mt-2 mr-2 align-self-start">Basic</div>
                        <div class="font-weight-bold flex-grow-1">
                            <div class="text-second font-size-lg">
                                Ultra
                            </div>
                            <span class="opacity-8">
                                <fa-icon [icon]="['far', 'user']" class="mr-1"></fa-icon>
                                <b>1,659</b>
                                subscribers
                            </span>
                        </div>
                        <div class="text-right hover-hide-wrapper">
                            <div class="font-weight-bold text-second">$893.00</div>
                            <span class="opacity-7">per month</span>
                        </div>
                        <div class="text-right hover-show-wrapper">
                            <button class="btn bg-white text-first d-40 rounded-circle p-0 ml-1"
                                    containerClass="tooltip-first"
                                   tooltip="View details" type="button">
                                <fa-icon [icon]="['far', 'user']" class="font-size-md mx-auto"></fa-icon>
                            </button>
                            <button class="btn bg-white text-danger d-40 rounded-circle p-0 ml-1"
                                    containerClass="tooltip-danger"
                                   tooltip="Remove" type="button">
                                <fa-icon [icon]="['fas', 'times']" class="font-size-md mx-auto"></fa-icon>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="col-xl-4">
        <div class="card card-box mb-5">
            <ul class="list-group list-group-flush">
                <li class="list-group-item pt-4 pb-4">
                    <div class="d-flex align-items-center flex-column flex-sm-row">
                        <div>
                            <div class="bg-premium-dark text-center text-white font-size-xl d-50 rounded-circle mb-3 mb-sm-0">
                                <fa-icon [icon]="['far', 'lightbulb']"></fa-icon>
                            </div>
                        </div>
                        <div class="pl-0 pl-sm-4">
                            <div class="d-block text-center d-sm-flex align-items-center">
                                <span class="font-size-lg">Business</span>
                                <span class="badge badge-neutral-info text-info ml-2">New</span>
                            </div>
                            <p class="text-black-50 mb-0">
                                Grow familiar with the countless...
                            </p>
                        </div>
                        <div class="mt-3 mt-sm-0 ml-sm-auto">
                            <button class="btn btn-second" type="button">
                            <span class="btn-wrapper--icon">
                                <fa-icon [icon]="['far', 'comment-dots']"></fa-icon>
                            </span>
                            </button>
                        </div>
                    </div>
                </li>
                <li class="list-group-item pt-4 pb-4">
                    <div class="d-flex align-items-center flex-column flex-sm-row">
                        <div>
                            <div class="bg-warning text-center text-white font-size-xl d-50 rounded-circle mb-3 mb-sm-0">
                                <fa-icon [icon]="['far', 'eye']"></fa-icon>
                            </div>
                        </div>
                        <div class="pl-0 pl-sm-4">
                            <div class="d-block text-center d-sm-flex align-items-center">
                                <span class="font-size-lg">Images</span>
                            </div>
                            <p class="text-black-50 mb-0">
                                Absorbed in the exquisite sense...
                            </p>
                        </div>
                        <div class="mt-3 mt-sm-0 ml-sm-auto">
                            <button class="btn btn-warning" type="button">
                            <span class="btn-wrapper--icon">
                                <fa-icon [icon]="['far', 'object-group']"></fa-icon>
                            </span>
                            </button>
                        </div>
                    </div>
                </li>
                <li class="list-group-item pt-4 pb-4">
                    <div class="d-flex align-items-center flex-column flex-sm-row">
                        <div>
                            <div class="bg-white border-primary border-2 text-center text-primary font-size-xl d-50 rounded-circle mb-3 mb-sm-0">
                                <fa-icon [icon]="['fas', 'lemon']"></fa-icon>
                            </div>
                        </div>
                        <div class="pl-0 pl-sm-4">
                            <div class="d-block text-center d-sm-flex align-items-center">
                                <span class="font-size-lg">Finance</span>
                            </div>
                            <p class="text-black-50 mb-0">
                                A wonderful serenity has taken ...
                            </p>
                        </div>
                        <div class="mt-3 mt-sm-0 ml-sm-auto">
                            <button class="btn btn-primary" type="button">
                                <span class="btn-wrapper--icon">
                                    <fa-icon [icon]="['fas', 'lemon']"></fa-icon>
                                </span>
                            </button>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
    </div>
</div>
